import { render } from "./ItEmblem.vue?vue&type=template&id=51190a79"
import script from "./ItEmblem.vue?vue&type=script&lang=js"
export * from "./ItEmblem.vue?vue&type=script&lang=js"

import "./ItEmblem.vue?vue&type=style&index=0&id=51190a79&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__